document.addEventListener('change', function (event) {
  var select = event.target.closest('[data-variant-select]');
  if (!select) return;
  var selected = select.options[select.selectedIndex];
  var price = document.querySelector('[data-product-price]');
  var button = document.querySelector('.add-button');
  var label = document.querySelector('[data-add-label]');
  if (price) price.textContent = selected.dataset.price || '';
  if (button) button.disabled = selected.dataset.available !== 'true';
  if (label) label.textContent = selected.dataset.available === 'true' ? 'Add to bag' : 'Sold out';
  if (selected.dataset.mediaId) {
    var gallery = document.querySelector('.product-gallery');
    var media = gallery && gallery.querySelector('[data-media-id="' + selected.dataset.mediaId + '"]');
    if (gallery && media) gallery.prepend(media);
  }
});
document.addEventListener('click', function(event) {
  var toggle = event.target.closest('[data-menu-toggle]');
  if (!toggle) return;
  var menu = document.getElementById('mobile-menu');
  if (!menu) return;
  var expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));
  toggle.setAttribute('aria-label', expanded ? 'Open menu' : 'Close menu');
  menu.hidden = expanded;
});
document.addEventListener('change', function(event) {
  var sort = event.target.closest('[data-sort-select]');
  if (!sort) return;
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', sort.value);
  url.searchParams.delete('page');
  window.location.assign(url.toString());
});
